import React from "react";
import LogoHeader from '../../assets/images/logo-header.png';
import bgInfo from "../../assets/images/bg-menu-info.png";
import btnProfile from "../../assets/images/BTN-Profile.png";
import btnProduct from "../../assets/images/BTN-Product.png";
import btnPrevilege from "../../assets/images/BTN-Previlege.png";
import useWindowDimensions from "../../functions/getScreen";
import { useNavigate } from "react-router-dom";

export default function TopBtn({ type }) {
    const navigate = useNavigate();
    const { width } = useWindowDimensions();
    return (
        <>
            <div className="relative container m-auto">
                <img className="bg" src={bgInfo} alt="Snow" />
                <div className="btn flex" style={{ gap: `${width / 7.8}px`, left: `${width / 7.8}px`, top: `${width / 15.6}px` }}>
                    <button onClick={() => navigate('/member-info')}>
                        <img className={type === 'info' ? "btn-info-profile btn-info-active-profile" : "btn-info"}
                            style={{ width: `${width / 7.8}px` }}
                            src={btnProfile} alt="Profile" />
                    </button>
                    <button onClick={() => navigate('/user-products')}>
                        <img className={type === 'product' ? "btn-info btn-info-active" : "btn-info"}
                            style={{ width: `${width / 7.8}px` }}
                            src={btnProduct} alt="Product" />
                    </button>
                    <button onClick={() => navigate('/member-coupon')}>
                        <img className={type === 'coupon' ? "btn-info btn-info-active" : "btn-info"}
                            style={{ width: `${width / 7.8}px` }}
                            src={btnPrevilege} alt="Previlege" />
                    </button>
                </div>

            </div>
        </>
    );
}
